import { useEffect } from 'react';
import { useSetAtom } from 'jotai';
import { waterMonitoring } from '../store/atoms/waterMonitoring.atom';
import { useSignalRListener } from './useSignalR';
import { MediaUrl } from '../utils/configuration';
import Cookies from 'js-cookie';
import { CSRF_TOKEN_KEY } from '../config/common';
import waterMonitoringSvc from '../services/api/waterMonitoring';

export const useWaterMonitoringSignalR = () => {
    const setWaterMonitoringData = useSetAtom(waterMonitoring);

    // Lắng nghe dữ liệu realtime từ SignalR
    const signalRData = useSignalRListener<any>({
        url: `${MediaUrl}hubs/waterMonitoring`,
        method: 'sendwatermonitoringrecord',
        headers: {
            'X-XSRF-TOKEN': Cookies.get(CSRF_TOKEN_KEY),
        },
    });

    useEffect(() => {
        if (signalRData) {
            setWaterMonitoringData(signalRData);
            console.log('signalRData',signalRData, 'time', signalRData[0].waterMonitoringTime)
        }
    }, [signalRData, setWaterMonitoringData]);

    // Fallback: Nếu sau 2s chưa có realtime thì gọi API lấy dữ liệu hiện tại
    useEffect(() => {
        const timer = setTimeout(async () => {
            setWaterMonitoringData(prev => {
                if (!prev) {
                    waterMonitoringSvc.getCurrentWaterMonitoring()
                        .then(res => setWaterMonitoringData(res.content))
                        .catch(err => console.error('Fallback API error', err));
                }
                return prev;
            });
        }, 500);

        return () => clearTimeout(timer);
    }, [setWaterMonitoringData]);
};